import { Link } from 'react-router-dom';

import { useAgentRefs } from '@/app/agentConversation/_context';
import { AGENT_KINDS } from '@/app/agentConversation/_enums';
import { pathForRef, refKey } from '@/app/agentConversation/_helpers';

/**
 * A record the assistant linked, inline in its text. Labelled from the API's
 * summary when there is one, otherwise from the link text. A link, so a click
 * opens the record and a Cmd-click opens it in a new tab.
 */
const RefChip = ({ refValue, children }) => {
  const refs = useAgentRefs();
  const kind = AGENT_KINDS[refValue.kind];
  const summary = refs[refKey(refValue)];
  const Icon = kind.icon;

  return (
    <Link
      to={pathForRef(refValue)}
      data-testid={`agent-ref-${refValue.uid}`}
      title={summary?.subtitle || kind.label}
      className="bg-muted text-foreground hover:bg-accent inline-flex max-w-full items-center gap-1 rounded-md border px-1.5 py-px align-baseline text-[0.85em] font-medium no-underline transition-colors"
    >
      <Icon className="text-muted-foreground size-3 shrink-0" />
      <span className="truncate">{summary?.title || children}</span>
    </Link>
  );
};

export default RefChip;
